import { NotifierType, ResponseErrorMessages, ResponseSuccessMessages } from 'src/common/notifierConstants';
import { push, ref, set } from 'firebase/database';

import { AppDispatch } from 'src/store/store';
import { dbRef } from 'src/firebaseConfig/firebaseConfig';
import { showNotifier } from 'src/store/reducers/notifierReducer';

export const saveContactUsDetails = async (
    name: string,
    email: string,
    mobile: string,
    setLoading: (isLoading: boolean) => void,
    dispatch: AppDispatch,
): Promise<void> => {
    const contactUsRef = ref(dbRef, 'contact-us');
    const newEntryRef = push(contactUsRef);

    setLoading(true);
    try {
        await set(newEntryRef, {
            dateAndTime: new Date().toLocaleString(),
            email,
            id: newEntryRef.key,
            mobile,
            name,
        });
        await sendEmail(email, name);
        dispatch(showNotifier({ message: ResponseSuccessMessages.CONTACT_US_SUCCESS_MESSAGE }));
    } catch (_error) {
        dispatch(showNotifier({ message: ResponseErrorMessages.SOMETHING_WENT_WRONG, type: NotifierType.ERROR }));
    } finally {
        setLoading(false);
    }
};

export const sendEmail = async (email: string, name: string): Promise<void> => {
    const data = {
        service_id: 'service_sn3r6cn',
        template_id: 'template_y6pcu1g',
        template_params: {
            email: email,
            name: name,
        },
        user_id: 'qweFDkqIpFFygyEBr',
    };

    try {
        await fetch('https://api.emailjs.com/api/v1.0/email/send', {
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'POST',
        });
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(`Error: ${error}`);
    }
};

export const handleGetInTouch = async (
    setLoading: (isLoading: boolean) => void,
    email: string,
    mobile: string,
    name: string,
    companyName: string,
    dispatch: AppDispatch,
): Promise<void> => {
    const getInTouch = ref(dbRef, 'get-in-touch');
    const newEntryRef = push(getInTouch);

    setLoading(true);
    try {
        await set(newEntryRef, {
            companyName,
            dateAndTime: new Date().toLocaleString(),
            email,
            id: newEntryRef.key,
            mobile,
            name,
        });
        await sendEmail(email, name);
        dispatch(showNotifier({ message: ResponseSuccessMessages.CONTACT_US_SUCCESS_MESSAGE }));
    } catch (_error) {
        dispatch(showNotifier({ message: ResponseErrorMessages.SOMETHING_WENT_WRONG, type: NotifierType.ERROR }));
    } finally {
        setLoading(false);
    }
};
